var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content animate-panel", attrs: { id: "content" } },
    [
      _c("h2", { staticClass: "m-n box-delivery-title" }, [
        _c("div", { staticClass: "delivery-title-icon" }, [
          _c("img", {
            staticClass: "img-responsive",
            attrs: { src: _vm.iconUrl, alt: "" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "delivery-title" }, [_vm._v("倉庫管理")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hpanel" },
        [
          _c("nav-tabs", {
            attrs: { tab: _vm.tab, hasWarehouseUsing: _vm.hasWarehouseUsing }
          }),
          _vm._v(" "),
          _c("tab-content", {
            attrs: { tab: _vm.tab, hasWarehouseUsing: _vm.hasWarehouseUsing }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2472dafe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2472dafe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/deliveryRequests/DeliveryRequests.vue
// module id = null
// module chunks = 